import { Product } from "../../../../data/entities";
import StockCardModal from "../../../../shared/components/StockCardModal";

const ProductStockCardModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
    <StockCardModal<Product>
        open={open}
        onClose={onClose}
        itemLabel="sản phẩm"
        itemLabelPlural="sản phẩm"
        itemListUrl="/products/"
        stockCardUrl="/products/stock-card/"
        itemIdsPayloadKey="product_ids"
        getItemCode={(product) => product.product_code}
        filenamePrefix="the_kho_san_pham"
    />
);

export default ProductStockCardModal;
